export default "__VITE_ASSET__YrPSFIJL__"